import React from "react";
import SidePanelLayout from "aldoo-ra/SidePanel";
import KPIDashboardOverview from "./KPIDashboardOverview";
import KPIExplorer from "./KPIExplorer";

const KPI = () => {
    return (
        <SidePanelLayout
            menuName="AdminKpiDashboards"
            tabs={{
                overview: KPIDashboardOverview,
                explorer: KPIExplorer,
            }}
        />
    );
};

export default KPI;
